import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconLinkedin = ({ id, color, width = 15.3, style, ...restProps }: IProps) => {
  const viewBoxWidth = 15.3;
  const viewBoxHeight = 13.8;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M.4 4.4h3v9.4h-3V4.4zm11.1-.1c-1.7 0-2.8.9-3 1.6V4.4H5.2v9.4h3.3v-5c0-.3 0-.6.1-.8.2-.6.7-1.2 1.6-1.2 1.2 0 1.7.8 1.7 2.1v4.9h3.3V8.6c.1-2.9-1.6-4.3-3.7-4.3zM1.8 0C.7 0 0 .7 0 1.6c0 .9.7 1.6 1.8 1.6s1.8-.7 1.8-1.6S2.9 0 1.8 0z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconLinkedin;
